<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="120px" :model="initForm" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="监控模板" prop="template_name">
            <el-select v-model="initForm.template_name" placeholder="请选择监控指标">
            <el-option
              v-for="monitorTemplate in monitorTemplateTypeList"
              :label="monitorTemplate.name"
              :key="monitorTemplate.name"
              :value="monitorTemplate.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="监控设备" prop="cloud">
            <el-select v-model="initForm.cloud" placeholder="选择云平台" style="width:160px;margin-right:10px;" size="small">
              <el-option
                v-for="cloud in clouds"
                :label="cloud"
                :key="cloud"
                :value="cloud"></el-option>
            </el-select>

            <el-input v-model="initForm.version" size="small" style="width:180px;margin-right:10px;" placeholder="请输入完整的固件版本"></el-input>
            <el-input v-model="initForm.mac" size="small" style="width:180px;margin-right:10px;" placeholder="请输入完整的设备MAC"></el-input>
            <el-button @click="fetchMonitorDevices" type="primary" size="small" style="margin-right:10px;">搜索设备</el-button>
          </el-form-item>

          <el-form-item>
            <el-select multiple v-model="initForm.device_name" placeholder="请选择监控设备" style="width:330px;" size="small">
            <el-option
              v-for="device in DeviceList"
              :label="device.name"
              :key="device.name"
              :value="device.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="定时周期" prop="schedule">
            <!-- 预设选项 -->
            <div style="margin-bottom: 10px;">
              <el-radio-group v-model="scheduleType" @change="onScheduleTypeChange">
                <el-radio label="preset">预设模式</el-radio>
                <el-radio label="custom">自定义</el-radio>
                <el-radio label="advanced">高级模式</el-radio>
              </el-radio-group>
            </div>

            <!-- 常用预设 -->
            <div v-if="scheduleType === 'preset'" style="margin-bottom: 10px;">
              <el-select v-model="presetSchedule" @change="onPresetChange" placeholder="选择预设设置" style="width: 200px;">
                <el-option label="每天上午8点8分" value="8 8 * * *"></el-option>
                <el-option label="每天上午9点8分" value="8 9 * * *"></el-option>
                <el-option label="每天凌晨0点" value="0 0 * * *"></el-option>
                <el-option label="每分钟" value="* * * * *"></el-option>
                <el-option label="每10分钟" value="*/10 * * * *"></el-option>
                <el-option label="每小时" value="0 * * * *"></el-option>
                <el-option label="每周一上午8点" value="0 8 * * 1"></el-option>
                <el-option label="每月1号上午8点" value="0 8 1 * *"></el-option>
              </el-select>
            </div>

            <!-- 自定义设置 -->
            <div v-if="scheduleType === 'custom'">
              <el-row :gutter="10">
                <el-col :span="4">
                  <div style="text-align: center; margin-bottom: 5px;">分钟</div>
                  <el-select v-model="cronParts.minute" @change="updateCronExpression" placeholder="分" size="small">
                    <el-option label="每分钟" value="*"></el-option>
                    <el-option label="每5分钟" value="*/5"></el-option>
                    <el-option label="每10分钟" value="*/10"></el-option>
                    <el-option label="每15分钟" value="*/15"></el-option>
                    <el-option label="每30分钟" value="*/30"></el-option>
                    <el-option v-for="i in 60" :key="i-1" :label="i-1" :value="(i-1).toString()"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <div style="text-align: center; margin-bottom: 5px;">小时</div>
                  <el-select v-model="cronParts.hour" @change="updateCronExpression" placeholder="时" size="small">
                    <el-option label="每小时" value="*"></el-option>
                    <el-option label="每2小时" value="*/2"></el-option>
                    <el-option label="每4小时" value="*/4"></el-option>
                    <el-option label="每6小时" value="*/6"></el-option>
                    <el-option label="每12小时" value="*/12"></el-option>
                    <el-option v-for="i in 24" :key="i-1" :label="i-1" :value="(i-1).toString()"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <div style="text-align: center; margin-bottom: 5px;">日</div>
                  <el-select v-model="cronParts.day" @change="updateCronExpression" placeholder="日" size="small">
                    <el-option label="每天" value="*"></el-option>
                    <el-option v-for="i in 31" :key="i" :label="i" :value="i.toString()"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <div style="text-align: center; margin-bottom: 5px;">月</div>
                  <el-select v-model="cronParts.month" @change="updateCronExpression" placeholder="月" size="small">
                    <el-option label="每月" value="*"></el-option>
                    <el-option v-for="i in 12" :key="i" :label="i" :value="i.toString()"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <div style="text-align: center; margin-bottom: 5px;">星期</div>
                  <el-select v-model="cronParts.week" @change="updateCronExpression" placeholder="周" size="small">
                    <el-option label="每天" value="*"></el-option>
                    <el-option label="周日" value="0"></el-option>
                    <el-option label="周一" value="1"></el-option>
                    <el-option label="周二" value="2"></el-option>
                    <el-option label="周三" value="3"></el-option>
                    <el-option label="周四" value="4"></el-option>
                    <el-option label="周五" value="5"></el-option>
                    <el-option label="周六" value="6"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>

            <!-- 高级模式 -->
            <div v-if="scheduleType === 'advanced'">
              <el-input v-model="initForm.schedule" placeholder="请输入定时周期, 格式与 crontab 相同"></el-input>
            </div>

            <!-- 显示当前表达式和说明 -->
            <div style="margin-top: 10px; padding: 8px; background-color: #f5f7fa; border-radius: 4px; font-size: 12px;">
              <div><strong>当前表达式：</strong>{{ initForm.schedule }}</div>
              <div><strong>执行说明：</strong>{{ getCronDescription(initForm.schedule) }}</div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="监控是否启用" prop="switch">
            <el-select v-model="initForm.switch" placeholder="启用或关闭设备监控">
            <el-option
              v-for="status in switchStatus"
              :label="status"
              :key="status"
              :value="status"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="任务说明" prop="desc">
            <el-input type="textarea" v-model="initForm.desc" placeholder="请输入任务说明"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SwitchStatus } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {},
    clouds: {},
    monitorTemplateTypeList: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      scheduleType: 'preset', // preset, custom, advanced
      presetSchedule: '',
      cronParts: {
        minute: '*',
        hour: '*',
        day: '*',
        month: '*',
        week: '*'
      },
      rules: {
        device_name: [{required: true, message: "请选择监控设备", trigger: "blur"}],
        template_name: [{required: true, message: "请选择监控模板", trigger: "blur"}],
        schedule: [{required: true, message: "请输入定时周期", trigger: "blur"}],
        status: [{required: true, message: "启用或禁用监控任务", trigger: "blur"}],
        desc: [{required: false, message: "请输入监控任务说明", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      },
      switchStatus: SwitchStatus,
      DeviceList: []
    };
  },
  watch: {
    'initForm.schedule': {
      handler(newVal) {
        if (newVal && this.scheduleType !== 'advanced') {
          this.parseCronExpression(newVal);
        }
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onScheduleTypeChange(type) {
      if (type === 'preset') {
        this.presetSchedule = '';
      } else if (type === 'custom') {
        this.updateCronExpression();
      }
    },
    onPresetChange(value) {
      this.initForm.schedule = value;
    },
    updateCronExpression() {
      const { minute, hour, day, month, week } = this.cronParts;
      this.initForm.schedule = `${minute} ${hour} ${day} ${month} ${week}`;
    },
    parseCronExpression(cronExpr) {
      if (!cronExpr) return;
      const parts = cronExpr.split(' ');
      if (parts.length === 5) {
        this.cronParts = {
          minute: parts[0],
          hour: parts[1],
          day: parts[2],
          month: parts[3],
          week: parts[4]
        };
      }
    },
    getCronDescription(cronExpr) {
      if (!cronExpr) return '';

      // 简单的 cron 表达式说明生成
      const presetDescriptions = {
        '* * * * *': '每分钟执行',
        '*/5 * * * *': '每5分钟执行',
        '*/10 * * * *': '每10分钟执行',
        '*/15 * * * *': '每15分钟执行',
        '*/30 * * * *': '每30分钟执行',
        '0 * * * *': '每小时执行',
        '0 0 * * *': '每天凌晨执行',
        '0 8 * * *': '每天上午8点执行',
        '8 8 * * *': '每天上午8点8分执行',
        '8 9 * * *': '每天上午9点8分执行',
        '0 8 * * 1': '每周一上午8点执行',
        '0 8 1 * *': '每月1号上午8点执行'
      };

      return presetDescriptions[cronExpr] || '自定义定时规则';
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              device_name: Array.isArray(this.initForm.device_name) ? this.initForm.device_name.join(',') : this.initForm.device_name,
              template_name: this.initForm.template_name,
              cloud: this.initForm.cloud,
              version: this.initForm.version !== undefined ? this.initForm.version : "",
              mac: this.initForm.mac !== undefined ? this.initForm.mac : "",
              schedule: this.initForm.schedule,
              status: +(this.initForm.switch === '开启'),
              desc: this.initForm.desc
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        // this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-monitor/tasks/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-monitor/tasks/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    },
    fetchMonitorDevices() {
      const params = {
        cloud: this.initForm.cloud,
        version: this.initForm.version,
        mac: this.initForm.mac
      };
      this.DeviceList = [];
      this.$http["get"](
        "device-monitor/devices/", params, (data) => {
          this.DeviceList = data.data;
        }
      );
    }
  }
};
</script>
